import { render, staticRenderFns } from "./AiEditPage.vue?vue&type=template&id=2a5a5534"
import script from "./AiEditPage.vue?vue&type=script&lang=ts"
export * from "./AiEditPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports